<div class="share-container">
  <ng-content></ng-content>
  <div class="overlay"
    [ngStyle]="{ 'right' : right ? '40px' : '-140px'}"
    *ngIf="shareVisible">
    <share-buttons [theme]="'modern-dark'"
      [include]="include"
      [show]="4"
      [url]="url"
      [title]="title"
      [description]="description"
      [image]="image"></share-buttons>
  </div>
</div>
